var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',[_c('div',[_vm._v("All contents © Copyright 2014-"+_vm._s(_vm.currentDate())+" Neuro Leap Corp. All rights reserved.")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://vividkidsblog.page"}},[_vm._v("vividkidsblog.page")])])
}]

export { render, staticRenderFns }